import React, { ReactNode, useState, useRef, useEffect } from "react";
import styles from "./Tooltip.module.scss";

type TooltipProps = {
  content: ReactNode;
  children: ReactNode;
  width?: string;
  height?: string;
  bottom?: string;
  left?: string;
  right?: string;
  tipPos?: boolean;
  hideHover?: boolean;
  className?: string;
};

const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  width = "auto",
  height = "auto",
  bottom = "20px",
  left = "0%",
  right = "0%",
  tipPos,
  hideHover,
  className = "",
}) => {
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  const toggleTooltip = () => {
    if (hideHover) {
      setVisible((prev) => !prev);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        hideHover &&
        wrapperRef.current &&
        !wrapperRef.current.contains(event.target as Node)
      ) {
        setVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [hideHover]);

  return (
    <div
      ref={wrapperRef}
      className={`tooltip_wrapper ${styles.tooltip_wrapper} ${
        hideHover ? styles.tooltip_with_click : ""
      }`}
      onClick={toggleTooltip}
    >
      {children}
      <span
        className={`tooltip ${styles.tooltip} ${className} ${tipPos ? styles.tip_position : ""} ${
          visible ? styles.visible : ""
        }`}
        style={{ width, height, bottom, left, right }}
      >
        <span className={`tooltip_text ${styles.tooltip_text}`}>{content}</span>
      </span>
    </div>
  );
};

export default Tooltip;
